/**
 * Estilos do NotificationBell (Bloco UI / UI.2).
 *
 * Visual inspirado nas referencias de design:
 * - Botao sino (FiBell) no header
 * - Badge pill com count em accent cobre (NAO pink — coerencia com paleta)
 * - Status dot accent quando ha pendencia
 * - Dropdown via Portal (escapa overflow do header)
 */
import styled from "styled-components";


export const BellWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;


export const BellButton = styled.button`
  position: relative;
  width: 36px;
  min-height: 36px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 999px;
  background: ${({ theme }) => theme.surface};
  color: ${({ theme }) => theme.textSecondary};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  transition: all 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.accent};
    border-color: ${({ theme }) => theme.accent};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.accent};
    outline-offset: 2px;
  }
`;


export const BellBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: ${({ theme }) => theme.accent};
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 0 0 2px ${({ theme }) => theme.surface};
`;


/**
 * Dropdown via Portal — posicionamento absoluto na viewport,
 * calculado por getBoundingClientRect do BellButton.
 */
export const Dropdown = styled.div`
  position: fixed;
  min-width: 320px;
  max-width: 380px;
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 12px;
  background: ${({ theme }) => theme.surface};
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.16);
  z-index: 9999;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;


export const DropdownHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  margin-bottom: 4px;

  h4 {
    margin: 0;
    font-size: 13px;
    font-weight: 700;
    color: ${({ theme }) => theme.textPrimary};
  }

  small {
    color: ${({ theme }) => theme.textTertiary};
    font-size: 11px;
  }
`;


export const DropdownItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.textPrimary};
  padding: 10px 12px;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.surfaceAlt};
    color: ${({ theme }) => theme.accent};
  }

  .label {
    font-size: 13px;
    font-weight: 500;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .count {
    min-width: 22px;
    padding: 2px 8px;
    border-radius: 999px;
    background: ${({ theme }) => theme.accent};
    color: #ffffff;
    font-size: 11px;
    font-weight: 700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  &[data-empty="true"] .count {
    background: ${({ theme }) => theme.surfaceAlt};
    color: ${({ theme }) => theme.textTertiary};
  }
`;


export const DropdownEmpty = styled.div`
  padding: 20px 12px;
  text-align: center;
  font-size: 13px;
  color: ${({ theme }) => theme.textTertiary};
`;
